module.exports = __webpack_public_path__ + "static/ClickedPassedAwayYellow-c25125145d39a685a56c1cd465cbfdaf.png";